import { ErrorIcon } from '@icons'

interface Props {
  resetErrorBoundary: () => void
}

function ErrorFallback({ resetErrorBoundary }: Props) {
  return (
    <div className='app-alert-wrapper'>
      <div className='app-alert'>
        <ErrorIcon />
        <p>An unexpected error occurred</p>
        <button className='app-try-again-button' type='button' onClick={resetErrorBoundary}>
          Go back to the home page
        </button>
      </div>
    </div>
  )
}

export default ErrorFallback
